import {TimeZone} from '@hconnect/common/types'
import {DateRangePicker} from '@hconnect/uikit/src/lib2'
import {Theme, useMediaQuery} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {getQuickSelectionItems} from '../utils'

type DateTimeRangePickerProps = {
  timeRangeParam: string
  onTimeRangeParamChange: (timeRange: string) => void
  disabled?: boolean
  timezone: TimeZone
}

export const DateTimeRangePicker: React.FC<DateTimeRangePickerProps> = ({
  timeRangeParam,
  onTimeRangeParamChange,
  disabled,
  timezone
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const selectionItems = getQuickSelectionItems(t, timezone)
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))

  return (
    <DateRangePicker
      onTimeRangeParamChange={onTimeRangeParamChange}
      timeRangeParam={timeRangeParam}
      singleDateSwitchLabel={t('quickSelection.pickSingleDate')}
      selectionItems={selectionItems}
      timezone={timezone}
      fullWidth={isMobile}
      withForm={true}
      disabled={disabled}
    />
  )
}
